import { CommonModule } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-create-document',
  standalone: true,
  imports: [FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './create-document.component.html',
  styleUrl: './create-document.component.css',
})
export class CreateDocumentComponent implements OnInit {
  documentForm!: FormGroup;
  oficinas: any[] = [];
  isFormDirty = false;
  idUnidadFuncional: string | null = null;
  user: any = null;
  hoy: string;
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {
    // Inicializar la fecha actual en formato YYYY-MM-DD
    const hoy = new Date();
    const utc5 = new Date(hoy.getTime() - 5 * 60 * 60 * 1000); // Restar 5 horas
    const fechaUTC5 = utc5.toISOString().split('T')[0];
    this.hoy = fechaUTC5;

    //this.hoy = hoy.toISOString().split('T')[0];
  }
  ngOnInit(): void {
    this.loadUserData();
    this.documentForm = this.fb.group({
      nombre: ['', [Validators.required, Validators.maxLength(100)]],
      descripcion: [''],
      tipo_documento: ['', Validators.required],
      fecha_inicio: [''],
      fecha_fin: [''],
      link_formato: [null, [Validators.pattern(/^https?:\/\/.+$/)]],
      id_oficina: [null, Validators.required],
    });

    this.loadOficinas();

    this.documentForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });
  }

  loadUserData(): void {
    const userData = localStorage.getItem('user');
    if (userData) {
      this.user = JSON.parse(userData);
      this.idUnidadFuncional = this.user?.id_unidad_funcional || null;
    } else {
      console.error('No se encontró información de usuario en localStorage.');
    }
  }

  loadOficinas() {
    let apiUrl = environment.apiUrl + '/oficina';

    if (this.idUnidadFuncional) {
      apiUrl += `?id_unidad_funcional=${this.idUnidadFuncional}`;
    }

    this.http.get(apiUrl).subscribe(
      (data: any) => {
        this.oficinas = data;
      },
      (error) => {
        console.error('Error al obtener oficinas:', error);
      }
    );
  }

  async onSubmit() {
    
    if (this.documentForm.invalid) {
      Swal.fire(
        'Advertencia',
        'Por favor, complete todos los campos.',
        'warning'
      );
      return;
    }

    const id_oficina = Number(this.documentForm.value.id_oficina);
    if (isNaN(id_oficina) || id_oficina <= 0) {
      Swal.fire('Advertencia', 'Seleccione una oficina válida.', 'warning');
      //alert('Seleccione una oficina válida.');
      return;
    }

    const result = await Swal.fire({
      title: '¿Está seguro?',
      text: '¿Quieres registrar el documento?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, registrar',
      cancelButtonText: 'No, cancelar',
    });

    if (!result.isConfirmed) return;

    // Mostrar loader
    Swal.fire({
      title: 'Procesando...',
      text: 'Por favor, espere.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      // Obtener usuario de localStorage de forma segura
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const id_rol_usuario = user?.id_rol_usuario;

      if (!id_rol_usuario) {
        throw new Error('No se pudo obtener el rol del usuario');
      }

      const payload = {
        ...this.documentForm.value,
        id_oficina,
        id_rol_usuario,
      };

      // Enviar petición
      await lastValueFrom(
        this.http.post<Response>(environment.apiUrl + '/documento', payload)
      );

      // Cerrar loader
      Swal.close();

      await Swal.fire({
        icon: 'success',
        title: 'Éxito',
        text: 'Documento creado con éxito',
      });

      this.router.navigate(['/documentos']);
    } catch (error: unknown) {
      Swal.close();

      let errorMessage = 'Error al crear el documento';

      if (error instanceof HttpErrorResponse) {
        errorMessage = error.error.message || errorMessage;
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }

      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    }
  }

  onBack() {
    if (this.isFormDirty && !confirm('¿Está seguro de salir?')) {
      return;
    }
    this.router.navigate(['/documentos']);
  }

  // @HostListener('window:beforeunload', ['$event'])
  // handleUnload(event: Event) {
  //   if (this.isFormDirty) {
  //     event.returnValue = true;
  //   }
  // }
}
